import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { gradeChangesApi } from "@/api";
import type { GradeChangeQuery } from "@/api";
import { QUERY_KEYS } from "@/constants";

/** Baho o'zgarishlari (eski → yangi), yangisi tepada. */
export const useGradeChanges = (query: GradeChangeQuery) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_GRADE_CHANGES, query],
    queryFn: () => gradeChangesApi.list(query),
    placeholderData: keepPreviousData,
    select: res => ({ rows: res.data, meta: res.meta }),
  });
